import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/home.css';
import homepageImage from '../assets/refactored/oliviaHomepageImage.jpg';


function home() {
  return (

  <div className='homepage-container'>
    <div className='homepage-background-image'>
      <img src={homepageImage} alt="Olivia Helman" className="homepage-background-img" loading="eager" />
      <div className='homepage-content'>
        <h2>vocalist, musicologist, communicator, creative</h2>
        <h3>click below to read more</h3>
        <Link to="/about" className="btn41-43 btn-41">enter</Link>
      </div>
    </div>
  </div>
          
    

  )
}

export default home
